import { z } from "zod";
import { uuidLoose } from "./uuid.js";
/**
 * Wire-format request query: `POST /v1/storefront/orders/:id/reorder?strategy=`.
 * Body is empty. The Idempotency-Key header is REQUIRED.
 */
export const ReorderRequestQuerySchema = z.object({
    strategy: z.enum(["merge", "replace"]).optional().default("merge"),
});
// Schema for runtime validation of *response* shapes in tests
export const SkippedLineSchema = z.object({
    orderItemId: uuidLoose,
    variantId: uuidLoose,
    titleSnapshot: z.string(),
    skuSnapshot: z.string(),
    quantity: z.number().int().positive(),
    reason: z.enum(["variant_soft_deleted", "variant_unknown"]),
});
export const PriceChangeSchema = z.object({
    variantId: uuidLoose,
    titleSnapshot: z.string(),
    oldUnitMinor: z.number().int().nonnegative(),
    newUnitMinor: z.number().int().nonnegative(),
    currency: z.literal("GBP"),
});
export const LineAdjustmentSchema = z.object({
    variantId: uuidLoose,
    titleSnapshot: z.string(),
    fromQty: z.number().int().nonnegative(),
    toQty: z.number().int().nonnegative(),
    reason: z.enum(["raised_to_moq", "rounded_to_increment", "low_stock"]),
    available: z.number().int().nonnegative().optional(),
});
